import { useState } from "react";
import { SendIcon, DownloadIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ContractListSection } from "../ContractList";
import { CreateInstanceDialog } from "../components/CreateInstanceDialog";
import { DownloadReportModal } from "../components/DownloadReportModal";
import {
  type CreateInstanceDialogOptions,
  generateDefaultEmptyInstanceInfo,
} from "../List";

export function CfrInstancesPage() {
  const [createInstanceInfo, setCreateInstanceInfo] =
    useState<CreateInstanceDialogOptions>(generateDefaultEmptyInstanceInfo());
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  const handleInstanceClick = (row: { customer_id?: string; id: string }) => {
    setCreateInstanceInfo({
      ...generateDefaultEmptyInstanceInfo(),
      suggestionId: "",
      selectedCustomerId: row.customer_id || "",
      selectedTemplateId: row.id || "",
      isDialogOpen: true,
    });
  };

  const handleBlankSend = () => {
    setCreateInstanceInfo({
      ...generateDefaultEmptyInstanceInfo(),
      isDialogOpen: true,
    });
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-sm text-muted-foreground uppercase tracking-wide">
            CFR
          </p>
          <h2 className="text-2xl font-bold">Instances</h2>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => setIsDownloadModalOpen(true)}>
            <DownloadIcon className="mr-2 h-4 w-4" />
            Download Report
          </Button>
          <Button variant="outline" onClick={handleBlankSend}>
            <SendIcon className="mr-2 h-4 w-4" />
            Send Template
          </Button>
        </div>
      </div>

      <ContractListSection onInstanceClick={handleInstanceClick} />

      {createInstanceInfo.isDialogOpen && (
        <CreateInstanceDialog
          open={createInstanceInfo.isDialogOpen}
          onOpenChange={(status: boolean) => {
            setCreateInstanceInfo((prev) => ({
              ...prev,
              isDialogOpen: status,
            }));
          }}
          onSuccess={() => {}}
          initialData={{
            customerId: createInstanceInfo.selectedCustomerId,
            templateId: createInstanceInfo.selectedTemplateId,
            suggestionId: createInstanceInfo.suggestionId,
            contractNumber: createInstanceInfo.contractNumber,
            contractType: createInstanceInfo.contractType,
            contractQuantity: createInstanceInfo.contractQuantity,
            documentTitle: createInstanceInfo.documentTitle,
          }}
        />
      )}

      {isDownloadModalOpen && (
        <DownloadReportModal
          open={isDownloadModalOpen}
          onOpenChange={setIsDownloadModalOpen}
        />
      )}
    </div>
  );
}

